import { render, staticRenderFns } from "./nouveau-contrat.vue?vue&type=template&id=2fc4876b"
import script from "./nouveau-contrat.vue?vue&type=script&lang=ts"
export * from "./nouveau-contrat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports